interface AggGoalTabConfig {
	id: string;
}

export const AGG_GOAL_TABS = {
	about: {
		id: 'agg-goal-about-tab',
	},
	updates: {
		id: 'agg-goal-updates-tab',
	},
	jiraAlign: {
		id: 'agg-goal-jira-align-tab',
	},
	jira: {
		id: 'agg-goal-jira-tab',
	},
	projects: {
		id: 'agg-goal-projects-tab',
	},
	learnings: {
		id: 'agg-goal-learnings-tab',
	},
	risks: {
		id: 'agg-goal-risks-tab',
	},
	decisions: {
		id: 'agg-goal-decisions-tab',
	},
} as const satisfies Record<string, AggGoalTabConfig>;

export type AggGoalTabName = keyof typeof AGG_GOAL_TABS;

export const DEFAULT_TAB: AggGoalTabName = 'about';

export const isAggGoalTab = (tabName: string): tabName is AggGoalTabName => {
	return tabName in AGG_GOAL_TABS;
};
